var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { getTopNavStyles } from './TopNavStyles';
import { getTestId } from '../../utils';
import { IconButton } from '../icon-button/IconButton';
import { Typography } from '../typography/Typography';
import { BLACK_800, BLACK_900 } from '../../constants';
export var TopNav = props => {
  var showLeftButton = props.showLeftButton,
    leftCtaAction = props.leftCtaAction,
    showRightButton = props.showRightButton,
    rightCtaAction = props.rightCtaAction,
    heading = props.heading,
    subHeading = props.subHeading,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'TopNav' : _props$testID,
    style = props.style,
    restProps = __rest(props, ["showLeftButton", "leftCtaAction", "showRightButton", "rightCtaAction", "heading", "subHeading", "testID", "style"]);
  var topNavStyles = getTopNavStyles();
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [topNavStyles.topNavContainer, style]
  }, restProps, {
    children: [_jsx(View, Object.assign({
      style: [topNavStyles.topNavLeftButton]
    }, {
      children: !!showLeftButton && _jsx(IconButton, Object.assign({
        controlState: "hover",
        size: "sm"
      }, leftCtaAction))
    })), _jsxs(View, Object.assign({
      style: [topNavStyles.topNavCenter]
    }, {
      children: [!!heading && _jsx(Typography, {
        text: heading,
        theme: "light",
        type: "body-para-xl-bold",
        color: BLACK_900
      }), !!subHeading && _jsx(Typography, {
        text: subHeading,
        theme: "light",
        type: "body-para-xxs",
        color: BLACK_800
      })]
    })), _jsx(View, Object.assign({
      style: [topNavStyles.topNavRightButton]
    }, {
      children: !!showRightButton && _jsx(IconButton, Object.assign({
        controlState: "hover",
        size: "sm"
      }, rightCtaAction))
    }))]
  }));
};